import { StudentListType, StudentEditType, StudentSelectListType } from '@/models/studentListModel'
import { PaginationStatus } from '@/models/paginationModel'
import { ApiResponseStudentList, ApiResponseStudentEditData } from '@/models/apiResponses/students'
import { ApiResponseStudyContentStudentList } from '@/models/apiResponses/studyContents'

export class StudentManagementUtils {
  /**
   * APIレスポンスを生徒一覧情報に変換する
   * @param apiResponse 生徒一覧APIレスポンス
   * @returns 生徒一覧情報
   */
  public static formatStudentDatas(apiResponse: ApiResponseStudentList): StudentListType[] {
    if (!apiResponse) return []

    return apiResponse.responses
  }

  /**
   * APIレスポンスからページネーションの状態を取得
   * @param apiResponse 生徒一覧APIレスポンス
   * @returns ページネーション情報
   */
  public static getPagenationStatus(apiResponse: ApiResponseStudentList): PaginationStatus | null {
    if (!apiResponse) return null

    return apiResponse.pagination
  }

  /**
   * システム管理者権限画面で使用する生徒編集情報を生成する
   * @param apiResponse 生徒情報取得APIレスポンス
   * @returns 生徒編集情報
   */
  public static buildAdminStudentEditData(apiResponse?: ApiResponseStudentEditData): StudentEditType {
    // APIレスポンスが渡されない場合は新規登録用の情報をセット
    if (!apiResponse) {
      return {
        academyId: '',
        branchId: '',
        gradeId: '',
        userName: '',
        bcbtCode: '',
        password: '',
        passwordConfirm: '',
        status: '',
      }
    }

    return {
      id: apiResponse.id,
      academyId: String(apiResponse.academyId),
      branchId: String(apiResponse.branchId),
      gradeId: String(apiResponse.gradeId),
      userName: apiResponse.userName,
      bcbtCode: apiResponse.bcbtCode,
      password: '',
      passwordConfirm: '',
      status: apiResponse.statusName,
    }
  }

  /**
   * 塾管理者権限画面で使用する生徒編集情報を生成する
   * @param apiResponse 生徒情報取得APIレスポンス
   * @returns 生徒編集情報
   */
  public static buildAcademyStudentEditData(apiResponse?: ApiResponseStudentEditData): StudentEditType {
    // APIレスポンスが渡されない場合は新規登録用の情報をセット
    if (!apiResponse) {
      return {
        branchId: '',
        gradeId: '',
        userName: '',
        bcbtCode: '',
        password: '',
        passwordConfirm: '',
        status: '',
      }
    }

    return {
      id: apiResponse.id,
      branchId: String(apiResponse.branchId),
      gradeId: String(apiResponse.gradeId),
      userName: apiResponse.userName,
      bcbtCode: apiResponse.bcbtCode,
      password: '',
      passwordConfirm: '',
      status: apiResponse.statusName,
    }
  }

  /**
   * 先生・講師権限画面で使用する生徒編集情報を生成する
   * @param apiResponse 生徒情報取得APIレスポンス
   * @returns 生徒編集情報
   */
  public static buildBranchStudentEditData(apiResponse?: ApiResponseStudentEditData): StudentEditType {
    // APIレスポンスが渡されない場合は新規登録用の情報をセット
    if (!apiResponse) {
      return {
        gradeId: '',
        userName: '',
        bcbtCode: '',
        password: '',
        passwordConfirm: '',
        status: '',
      }
    }

    return {
      id: apiResponse.id,
      gradeId: String(apiResponse.gradeId),
      userName: apiResponse.userName,
      bcbtCode: apiResponse.bcbtCode,
      password: '',
      passwordConfirm: '',
      status: apiResponse.statusName,
    }
  }

  /**
   * 生徒の名前を取得する
   * @param apiResponse 生徒情報取得APIレスポンス
   * @returns 生徒氏名
   */
  public static getStudentUserName(apiResponse: ApiResponseStudentEditData): string {
    if (!apiResponse) return ''

    return apiResponse.userName
  }

  /**
   * 履歴管理・生徒を選ぶ画面で使用する生徒一覧情報に変換する
   * @param apiResponse 生徒一覧APIレスポンス
   * @returns 履歴画面で表示する生徒一覧情報
   */
  public static formatStudentSelectDatas(apiResponse: ApiResponseStudyContentStudentList): StudentSelectListType[] {
    if (!apiResponse) return []

    return apiResponse.responses.map((response) => {
      return {
        id: response.studentId,
        nickName: response.studentName,
        gradeName: response.gradeName,
        statusName: response.status,
        lastMinuteCheckStatus: `${response.lastCheck}科目実施`,
        resolveStatus: `${response.retry}科目実施`,
      }
    })
  }

  /**
   * 履歴管理・生徒を選ぶ画面で使用するページネーションの状態を取得
   * @param apiResponse 生徒一覧APIレスポンス
   * @returns 履歴画面で表示するページネーション情報
   */
  public static getStudentSelectPagenationStatus(
    apiResponse: ApiResponseStudyContentStudentList
  ): PaginationStatus | null {
    if (!apiResponse) return null

    return apiResponse.pagination
  }
}
